import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, Flex, Button, Image, Text, useColorMode, Stack, Grid, GridItem, Stat, StatLabel, StatNumber, Icon, Skeleton } from "@chakra-ui/react";
import { FaWalking, FaHeart, FaWeight, FaRulerVertical, FaHeartbeat, FaArrowLeft } from 'react-icons/fa';
import Logo from "../fitness.png";
import Loading from "./Loader";
import { useNavigate } from "react-router-dom";
import MasterDataFood from "./DashboardMasterFood";
import MasterDataUser from "./DashboardMasterUser";
import MasterMenuMenu from "./DashboardMasterMenu";
import MasterMenuAktifitas from "./DashboardMasterAktifitas";
import MasterMenuFavorit from "./DashboardMasterFavorit";

export default function DashboardMeal() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [activePage, setActivePage] = useState('dashboard');
  const { colorMode } = useColorMode();

  // State buat simpan jumlah data
  const [countUser, setCountUser] = useState(0);
  const [countFood, setCountFood] = useState(0);
  const [countMenu, setCountMenu] = useState(0);
  const [countAktifitas, setCountAktifitas] = useState(0);
  const [countFavorit, setCountFavorit] = useState(0);

  const today = new Date();
  const hari = ['Min','Sen','Sel','Rab','Kam','Jum','Sab'];
  const bulan = ['Jan','Feb','Mar','Apr','Mei','Jun','Jul','Agu','Sep','Okt','Nov','Des'];
  const tanggal = `${hari[today.getDay()]}, ${today.getDate()} ${bulan[today.getMonth()]}`;

  // Load semua count pas buka dashboard
  useEffect(() => {
    const loadCounts = async () => {
      try {
        // 1. Count User
        const resUser = await axios.get(`${process.env.REACT_APP_API_BASE}/get-users`);
        setCountUser(resUser.data.users?.length || 0);

        // 2. Count Foods
        const resFood = await axios.get(`${process.env.REACT_APP_API_BASE}/get-foods?limit=1`);
        setCountFood(resFood.data.total || resFood.data.foods?.length || 0); // kalau API ada total, pake total

        // 3. Count Menu Makanan
        const resMenu = await axios.get(`${process.env.REACT_APP_API_BASE}/api/get-menu-count`);
        setCountMenu(resMenu.data.total || 0);

  const resAktifitas = await axios.get(`${process.env.REACT_APP_API_BASE}/get-activities-count`);
    console.log('Aktifitas:', resAktifitas.data); // cek di F12 > Console
    setCountAktifitas(resAktifitas.data.total || 0);

    const resFavorit = await axios.get(`${process.env.REACT_APP_API_BASE}/get-food-diary?limit=1`);
setCountFavorit(resFavorit.data.total  || resFavorit.data.food_diary.length  || 0);

      } catch (err) {
        console.error('Gagal load count:', err);
      } finally {
        setIsLoading(false);
      }
    };

    const email = localStorage.getItem('userEmail');
    if (!email) navigate('/login');
    else loadCounts();
  }, [navigate]);

  // Component Card biar rapi
  const MasterCard = ({ title, count, icon, color, onClick }) => (
    <GridItem
      as={Button}
      bgGradient={color}
      p={4}
      rounded="xl"
      shadow="lg"
      color="white"
      h="120px"
      cursor="pointer" // gambar tangan
      _hover={{ transform: 'translateY(-4px)', shadow: '2xl' }}
      transition="all 0.2s"
      onClick={onClick}
      justifyContent="flex-start"
    >
      <Flex justify="space-between" align="center" w="full">
        <Stat textAlign="left">
          <StatLabel fontSize="sm" opacity={0.9}>{title}</StatLabel>
          <Text fontSize="xs" opacity={0.8} mt={0.5}>{tanggal}</Text>
          {isLoading? (
            <Skeleton height="30px" width="50px" mt={1} startColor="whiteAlpha.400" endColor="whiteAlpha.600" />
          ) : (
            <StatNumber fontSize="3xl" fontWeight="bold" mt={1}>{count}</StatNumber>
          )}
        </Stat>
        <Icon as={icon} boxSize={8} opacity={0.8} />
      </Flex>
    </GridItem>
  );

  return (
    <>
      {isLoading && activePage === 'dashboard'? <Loading /> : (
        <Box>
          {/* Header Sticky */}
          <Box bg={colorMode === "light"? "black" : "pink.800"} px={{ base: 2, md: 4 }} py={2} color="white" position="sticky" top={0} zIndex={10}>
            <Flex align="center" justify="space-between">
              <Flex align="center">
                <Image src={Logo} alt="Logo" boxSize="40px" mr={2} />
                <Text fontSize="lg" fontWeight="bold">Master Data</Text>
              </Flex>
              <Button size="sm" leftIcon={<FaArrowLeft />} variant="outline" colorScheme="whiteAlpha" onClick={() => navigate("/dashboard")}>
                Kembali
              </Button>
            </Flex>
          </Box>

          {/* Dashboard Cards */}
          {activePage === 'dashboard' && (
            <Flex direction="column" w="100%" p={4}>
              <Stack spacing={6}>
                <Text fontSize="2xl" fontWeight="bold">Master Data</Text>

                <Grid templateColumns={{ base: "1fr", sm: "1fr 1fr", lg: "repeat(5, 1fr)" }} gap={4}>

                  <MasterCard
                    title="Master Data User"
                    count={countUser}
                    icon={FaWalking}
                    color="linear(to-br, blue.400, blue.600)"
                    onClick={() => setActivePage('user')}
                  />

                  <MasterCard
                    title="Master Makanan"
                    count={countFood}
                    icon={FaHeart}
                    color="linear(to-br, teal.400, teal.600)"
                    onClick={() => setActivePage('food')}
                  />

                  <MasterCard
                    title="Master Menu Makanan"
                    count={countMenu}
                    icon={FaWeight}
                    color="linear(to-br, purple.400, purple.600)"
                    onClick={() => setActivePage('menu')}
                  />

                  <MasterCard
                    title="Master Aktifitas"
                    count={countAktifitas}
                    icon={FaRulerVertical}
                    color="linear(to-br, orange.400, orange.600)"
                    onClick={() => setActivePage('aktifitas')}
                  />

                  <MasterCard
                    title="Favorit Makanan"
                    count={countFavorit}
                    icon={FaHeartbeat}
                    color="linear(to-br, pink.400, pink.600)"
                    onClick={() => setActivePage('favorit')}
                  />

                </Grid>
              </Stack>
            </Flex>
          )}

          {/* Routing ke program masing2 */}
          {activePage === 'user' && <MasterDataUser onBack={() => setActivePage('dashboard')} />}
          {activePage === 'food' && <MasterDataFood onBack={() => setActivePage('dashboard')} />}
          {activePage === 'menu' && <MasterMenuMenu onBack={() => setActivePage('dashboard')} />}
          {activePage === 'aktifitas' && <MasterMenuAktifitas onBack={() => setActivePage('dashboard')}/>} 
          {activePage === 'favorit' && <MasterMenuFavorit onBack={() => setActivePage('dashboard')} />}
        </Box>
      )}
    </>
  );
}